import * as React from 'react';


interface DataStringProps {
    title: string,
    value?: string | null | undefined | number,
    isNormal?: boolean,
    valueColor?: string
    titleColor?: string

}


export default class DataString extends React.PureComponent<DataStringProps> {

    public render() {
        return (
            <div className='data-string__wrapper'>
                <div className={`${this.props.isNormal ? "name-passive--6" : "name-passive--8"} data-string__name`} style={{ color: this.props.titleColor }}>{this.props.title}</div>
                {
                    this.props.value !== undefined && this.props.value !== null ?
                        <div className={`${this.props.isNormal ? "value-text--normal" : "value-text--bold"} data-string__value`} style={{ color: this.props.valueColor }}>{this.props.value}</div>
                        : <div className='data-string__children'>{this.props.children}</div>
                }
            </div >
        );
    }
}

export class InfoString extends React.PureComponent<DataStringProps> {

    public render() {
        return (
            <div className='info-string__wrapper'>
                <div className={`name-passive--8 `}>{this.props.title}</div>
                <div className={`value-text--normal `} style={{ color: this.props.valueColor }}>{this.props.value}</div>
            </div >
        );
    }
}